import axios, { AxiosRequestConfig } from 'axios';
import useAuthStore from 'store/authStore';

const TOLLING_ADMIN_BASE_URL: string = import.meta.env.VITE_TOLLING_ADMIN_API_URL || '';
const TOLLING_ADMIN_API_KEY: string = import.meta.env.VITE_TOLLING_ADMIN_API_KEY || '';

if (import.meta.env.MODE === 'development') {
  console.log(
    'import.meta.env.VITE_TOLLING_ADMIN_API_URL',
    import.meta.env.VITE_TOLLING_ADMIN_API_URL
  );
}
if (import.meta.env.VITE_ENVIRONMENT !== 'production') {
  console.log(import.meta.env);
}

// Setup the (Axios) request configuration
const config: AxiosRequestConfig = {
  baseURL: TOLLING_ADMIN_BASE_URL,
  withCredentials: false,
  timeout: 30 * 1000,
  headers: {
    'Ocp-Apim-Subscription-Key': TOLLING_ADMIN_API_KEY,
  },
};

export const osbApiAxios = axios.create(config);

osbApiAxios.interceptors.request.use(
  async (config) => {
    const authToken = await useAuthStore.getState().acquireToken();
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken.accessToken}`;
    }
    return config;
  },
  (error) => {
    console.error('osbApiAxios interceptor error', error);
    return Promise.reject(error);
  }
);
